import { useState } from 'react'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextAreaField from '../../../FormLegacy/FormFieldsV2/TextAreaField'
import Icon from '../../../Icons'
import { getAssetLink } from '../../../../helpers/get-asset-link'
import { ZoomFrame } from '@/components/ui/zoomable-image'

const JobSummaryModal = ({
  jobSummaryMessage,
  setJobSummaryMessage,
  jobSummaryPhotos,
  handleCancel,
  updateJobSummaryData,
}) => {
  const { t } = useTranslation(['maintenance', 'common'])
  const [isEditModeEnabled, setIsEditModeEnabled] = useState(false)
  const photosTitle = t('maintenance:requestPreview.jobSummary.photosAfterRepair')
  const photoUrls = (jobSummaryPhotos || [])
    .slice(0, 3)
    .filter(Boolean)
    .map((file) => getAssetLink({ path: 'chitown-building', file }))

  const editDescription = () => {
    updateJobSummaryData({ jobSummaryMessage })
    setIsEditModeEnabled(false)
    handleCancel()
  }

  return (
    <div className="maintenance-request-job-summary">
      <div className="maintenance-request-job-summary__container">
        <div className="window-header">
          <div className="title">
            {isEditModeEnabled
              ? t('maintenance:requestPreview.jobSummary.editTitle')
              : t('maintenance:requestPreview.jobSummary.title')}
          </div>
          <div className="navi-button" onClick={() => handleCancel()}>
            <Icon icon="cross" />
          </div>
        </div>
        <div className="main-view">
          {isEditModeEnabled ? (
            <TextAreaField
              name={'job summary message'}
              placeholder={t('maintenance:requestPreview.jobSummary.message.placeholder')}
              value={jobSummaryMessage || ''}
              onChange={(e) => setJobSummaryMessage(e.target.value)}
              maxLength="500"
              style={{ width: '100%' }}
            />
          ) : (
            <div className="single-row" style={{ margin: '0px 0px', alignItems: 'flex-start' }}>
              {jobSummaryPhotos && jobSummaryPhotos.length ? (
                <div>
                  <p>{photosTitle}</p>
                  <div className="photos-list">
                    {photoUrls.map((url, index) => (
                      <ZoomFrame
                        key={url}
                        className="photo-frame"
                        hintSize="2rem"
                        src={url}
                        title={photosTitle}
                        images={photoUrls}
                        initialIndex={index}
                      >
                        <img src={url} alt="" />
                      </ZoomFrame>
                    ))}
                  </div>
                </div>
              ) : null}
              <p>
                {jobSummaryMessage || t('maintenance:requestPreview.jobSummary.noSummaryMessage')}
              </p>
            </div>
          )}
        </div>
        <div className="window-footer">
          <div className="footer-buttons">
            <button className={'button button-gray is-block'} onClick={() => handleCancel()}>
              {t('common:actions.cancel')}
            </button>
            {isEditModeEnabled ? (
              <button
                onClick={() => editDescription()}
                className={'button button-primary is-block'}
              >
                {t('common:actions.save')}
              </button>
            ) : (
              <button
                onClick={() => setIsEditModeEnabled(true)}
                className={'button button-primary is-block'}
              >
                {t('common:actions.edit')}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

JobSummaryModal.propTypes = {
  jobSummaryMessage: PropTypes.string,
  setJobSummaryMessage: PropTypes.func,
  updateJobSummaryData: PropTypes.func,
  handleCancel: PropTypes.func,
  jobSummaryPhotos: PropTypes.array,
  maintenanceId: PropTypes.number,
}

export default JobSummaryModal
